// Vue
import { Component, Vue } from "vue-property-decorator";
// Mobx
import { autorun } from "mobx";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Enums

import "#/modules/index";
import { User } from "@mgs/ci2019-common/src/models/user/User";
import { IRegion } from "@mgs/ci2019-common/src/interfaces/IRegion";
import { Api } from "#/api";
import { parsePlaceholderText } from "#/common/Utils";
import { HeadlineNews } from "../../../components/headline_news/HeadlineNews";
import { ConversionworldMenu } from "../../../components/conversionworld_menu/ConversionworldMenu";
import { ConversionworldSearchLayer } from "../../../components/conversionworld_search_layer/ConversionworldSearchLayer";

@Observer
@Component({
  mixins: [template],
  components: {
    HeadlineNews,
    ConversionworldMenu,
    ConversionworldSearchLayer,
  },
})
export class ConversionworldLayout extends Vue {
  private isMobileMenuOpen = false;

  private activeFlyout = "";

  created() {
    this.$eventBus.$on(
      "conversion-world-open-search-layer",
      this.handleOpenSearchLayer
    );
  }

  beforeDestroy() {
    this.$eventBus.$off(
      "conversion-world-open-search-layer",
      this.handleOpenSearchLayer
    );
  }

  public handleOpenSearchLayer() {
    this.activeFlyout = "search";
  }

  public handleBodyPaddingChanged(padding: number) {
    this.$store.ui.bodyPadding = padding;
  }

  public handleActiveOverlay(overlay) {
    /*if (overlay) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }*/
  }

  public get headerOptions() {
    return {
      topMenuBefore: [],
      menu: [
        {
          id: "search",
          overlay: true,
          icon: this.$icons.SEARCH,
          text: (this as any).$t("HEADER_CW_SEARCH"),
        },
        {
          id: "menu",
          overlay: true,
          icon: this.$icons.MENU,
          text: (this as any).$t("HEADER_CW_MENU"),
        },
      ],
    };
  }

  public handleFooterClick(itemName: string) {
    // @ts-ignore
    this.$refs["Header"].openPolicy(itemName);
  }

  public handleCookieAccept(accepted: boolean) {
    if (accepted) {
      // @ts-ignore
      window._paq.push(["rememberConsentGiven"]);
    }

    Api.authService.updateTrackingStatus(accepted);
    // @ts-ignore
    this.$refs["CookieLayer"].handleAgree();
  }

  public parseCookieLinkText(text: string, start: string, end: string) {
    return parsePlaceholderText(text, start, end);
  }

  public handleIsMobileMenuOpen(event) {
    this.isMobileMenuOpen = event;
  }

  public onCloseMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  public handleActiveFlyout(id) {
    this.activeFlyout = id;
    if (id === "menu" || id === "search") {
      this.isMobileMenuOpen = true;

      if (id === "search") {
        Vue.nextTick(() => {
          // @ts-ignore
          this.$refs["searchLayer"].focusInput();
        });
      }
    } else {
      this.isMobileMenuOpen = false;
    }
  }
}
